import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import styled, {css} from 'styled-components'

export const StyledPatientDetailsCtaButtonLink = styled(ButtonLink)<{$isReadOnly?: boolean}>`
    ${({$isReadOnly}) =>
        $isReadOnly &&
        css`
            pointer-events: none;
        `}
    font-weight: 400;
    & b {
        font-weight: 500;
    }
`
